export enum CARD_TYPE {
    MASTER_CARD = 1,
    VISA = 2
}

export enum CARD_PROVIDER_TYPE {
    INTERCASH = 'i'
}

export enum CARD_TRANSFER_STATE_TYPE {
    AUTHORIZED = 'authorized',
    SETTLED = 'settled',
    DECLINED = 'declined'
}

export enum CARD_TRANSFER_TYPE {
    PRE_AUTHORIZATION = 'preAuthorization',
    AUTHORIZATION = 'authorization',
    TRANSACTION = 'transaction'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/constants/card.types.ts